// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--4ed1801","itemLabel":"itemLabel--bdf4b7b","disabled":"disabled--e768f8e"};